export default {"src":"/_next/static/media/modern-furniture.3fcfe6ba.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};